
import { Component, Vue } from 'vue-property-decorator'
import router from '../../router'
import { agreeConflictTimetable } from '@/api'
const that = new Vue({ router })
@Component({ name: 'Relation' })
export default class Relation extends Vue {
  private show = false
  private conflictDetailsDialog = false
  private returnData: any = []
  private async onSetClick () {
    // 强行修改冲突
    const result = await agreeConflictTimetable({ data: this.returnData })
    this.show = false
    if (this.returnData.conflictType === 1) { // 入班匹配成功页面回退一页
      that.$router.go(-1)
    } else { // 刷新当前页面
      that.$router.go(0)
    }
  }
}
